import React from 'react';
import Button from '../tags/button/Button';
import { useWindowSize } from 'usehooks-ts';

const ContactBanner = ({
  title = 'Can’t find your answer?',
  body = 'Contact us and we’ll get back to you as soon as we can.',
  labelBtn = 'Contact Us',
  href = '/contact',
}: {
  title?: string;
  body?: string;
  labelBtn?: string;
  href?: string;
}) => {
  const { width } = useWindowSize();

  return (
    <section
      className={`relative mb-[8rem] pt-[12.2rem] pb-[22rem] md:mb-0 md:pt-[7.5rem] md:pb-[11rem] xl:pt-[9.5rem] `}
    >
      <div className={`container `}>
        <h2 className='text-center text-[2.4rem] font-bold md:text-[2.8rem] xl:text-[4.2rem]'>
          {title}
        </h2>
        <p className='py-[1.6rem] text-center text-black xl:py-[2.4rem]'>
          {body}
        </p>
        <div className='flex justify-center'>
          <Button label={labelBtn} type='link' path={href} />
        </div>
        <div className='flex justify-center'>
          <img
            src={
              width > 767
                ? '/img/home-help-center@2x.svg'
                : '/img/home-help-center.svg'
            }
            alt='home'
            className='absolute bottom-0 md:right-0 md:bottom-[-1rem] md:h-[15.4rem] md:w-[24.9rem] xl:h-[26rem] xl:w-[46.7rem]'
          />
        </div>
      </div>
    </section>
  );
};

export default ContactBanner;
